<template>
	<transition name="el-fade-in">
		<div class="w100p h100p pos-fix pos-c z5000 alarm-loading alarm-box-loading" v-show="animateLoading">
			<div class="w100p h100p pos-relative bg-alarm-box-loading">
				<div class="w600 h100 pos-abs pos-c loading-box-wrap">
					<div class="mg-b10 text-center">
						<svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
					</div>
					<div class="color-white f20 text-center">{{ message }}</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
  export default {
    name: "loading",
    
    data () {
      return {
        animateLoading: false,
        message : '',
	      timer: null
      }
    },
    
    methods: {
      openLoading (text, num) {
        let timeout = !this.isInvalid(num) && typeof(num) === 'number' ? num : 20000;
        this.message = text;
        this.animateLoading = true;
	      if (!this.isInvalid(this.timer)) {
        	clearTimeout(this.timer);
        	this.timer = setTimeout(() => {
		        this.closeLoading();
	        }, timeout);
        } else {
	        this.timer = setTimeout(() => {
		        this.closeLoading();
	        }, timeout);
        }
      },
      
      closeLoading () {
        this.message = '';
        this.animateLoading = false;
      },
    }
  }
</script>

<style>
  .alarm-box-loading {  }
  .alarm-box-loading .loading-box-wrap {  }
  .alarm-box-loading .bg-alarm-box-loading { background: rgba(0, 0, 0, 0.7); }
  
  
  
  .alarm-box-loading .icon-loading {
    animation: animation-refresh 1s linear 0s infinite;
  }

  .alarm-box-loading .circular {
    height: 50px;
    width: 50px;
	  animation: rotating 1s linear infinite;
  }

  .alarm-box-loading .circular .path {
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90,150;
    stroke-dashoffset: 0;
    stroke-width: 5;
    stroke: #fff;
    stroke-linecap: round;
  }
  
  
  
  @-webkit-keyframes animation-refresh {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes animation-refresh {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes loading-dash {
	  0%{ stroke-dasharray:1,200; stroke-dashoffset: 0 }
	  50%{ stroke-dasharray:90,150; stroke-dashoffset: -40px }
	  100%{ stroke-dasharray:90,150; stroke-dashoffset: -120px }
  }
  
  @keyframes loading-dash {
	  0%{ stroke-dasharray: 1,200; stroke-dashoffset: 0 }
	  50%{ stroke-dasharray: 90,150; stroke-dashoffset: -40px }
	  100%{ stroke-dasharray: 90,150; stroke-dashoffset: -120px }
  }
</style>
